import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { appRoutes } from '@tekman/onmat/constants';
import { Profile } from '@tekman/onmat/models';
import { ProfileFacade } from '@tekman/onmat/store/profile';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { UserService } from '@tekman/onmat/service/generic';

@Injectable({
  providedIn: 'root',
})
export class isRoleGuard implements CanActivate {
  constructor(private readonly profileFacade: ProfileFacade, private readonly _router: Router, private userService: UserService) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.profileFacade.profile$.pipe(
      map((_profile: Profile) => _profile.roles),
      switchMap(roles => {
        if (this.userService.isTeacher()) {
          return of(true);
        }
        return of(this._router.createUrlTree([appRoutes.error404]));
      })
    );
  }
}
